/**
 * ゲーム設定パラメータ
 */
export interface GameConfig {
  // 進行
  totalPitches: number; // 1プレイ球数

  // 投球
  pitchSpeed: number; // 投球速度（ピクセル/秒）

  // タイミング判定
  bestWindowMs: number; // ベスト判定の時間幅（ミリ秒）
  goodWindowMs: number; // グッド判定の時間幅（ミリ秒）
  veryEarlyWindowMs: number; // とても早い判定の時間幅（ミリ秒）
  veryLateWindowMs: number; // とても遅い判定の時間幅（ミリ秒）

  // 失敗振分
  earlyIsFoul: boolean; // 早すぎの場合にFoulとするか

  // 角度バー
  barSpeed0: number; // 角度バーの初期速度
  barAccel: number; // 角度バーの加速度
  barMinAngle: number; // 角度バーの最小角度（度）
  barMaxAngle: number; // 角度バーの最大角度（度）
  bestBandWidth: number; // Best帯の幅（度）

  // 飛距離計算
  baseDistance: number; // 基礎距離（メートル）
  fullBestMultiplier: number; // フルBest係数（タイミング最上位かつ角度Best帯のとき）

  // HR判定
  hrDistanceThreshold: number; // HR閾値（メートル）

  // スコア
  scorePerMeter: number; // 1メートルあたりのスコア

  // 拡張フック（将来拡張用）
  extraDistanceMultiplier: number; // 追加距離係数
  extraDistanceAdd: number; // 追加距離加算値
}

/**
 * デフォルトゲーム設定
 */
export const defaultGameConfig: GameConfig = {
  totalPitches: 10,
  pitchSpeed: 500,
  bestWindowMs: 100, // ベスト判定の時間幅（ミリ秒）
  goodWindowMs: 200, // グッド判定の時間幅（ミリ秒）
  veryEarlyWindowMs: 50, // とても早い判定の時間幅（ミリ秒）
  veryLateWindowMs: 50, // とても遅い判定の時間幅（ミリ秒）
  earlyIsFoul: true,
  barSpeed0: 20, // カーソルの動きを遅く
  barAccel: 5,
  barMinAngle: 0, // 最小角度（度）- 地面と水平（0度）
  barMaxAngle: 90, // 最大角度（度）- 直角（90度）
  bestBandWidth: 10, // Best帯の幅（度）- 25度から35度の範囲（30度±5度、バレルゾーン）
  baseDistance: 20, // BEST+30度で表示200m前後になるように調整
  fullBestMultiplier: 1.2,
  hrDistanceThreshold: 95, // HR判定：95m以上（表示倍率適用後）
  scorePerMeter: 10,
  extraDistanceMultiplier: 1.0,
  extraDistanceAdd: 0,
};

/**
 * タイミング判定結果
 */
export enum TimingResult {
  VERY_EARLY = 'VERY_EARLY', // とても早い
  EARLY = 'EARLY', // 早い
  BEST = 'BEST', // ベスト
  LATE = 'LATE', // 遅い
  VERY_LATE = 'VERY_LATE', // とても遅い
}

/**
 * 打球結果
 */
export enum HitResult {
  HR = 'HR', // ホームラン
  FOUL = 'Foul', // ファウル
  MISS = 'Miss', // ミス
}
